export const skillsList = [
  {
    id: 1,
    label: "HTML",
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-plain-wordmark.svg",
  },
  {
    id: 2,
    label: "CSS3",
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original-wordmark.svg",
  },
  {
    id: 3,
    label: "Bootstrap",
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
  },
  {
    id: 4,
    label: "Javascript",
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  },
  {
    id: 5,
    label: "React",
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original-wordmark.svg",
  },
  {
    id: 6,
    label: "Express",
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original-wordmark.svg",
  },
  {
    id: 7,
    label: "Mongodb",
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original-wordmark.svg",
  },
  {
    id: 8,
    label: "Firebase",
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain-wordmark.svg",
  },
  {
    id: 9,
    label: "Git",
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain-wordmark.svg",
  },
];

export const projectsList = [
  {
    label: "Ecommerce",
    imgSrc: "/static/images/ecommerce.png",
    src: "https://ecommerce-storeapp.herokuapp.com/",
    githubSrc: "https://github.com/kalyan-maker/ecommerce",
    description:
      "This is an Ecommerce website with Add to cart feature, payment through Stripe,and filtering the products.",
    stack: ["React.js", "Express.js", "MonogoDB"],
  },
  {
    label: "Quiz App",
    imgSrc: "/static/images/quiz.png",
    src: "https://reactfirebase-quizapp.herokuapp.com/",
    githubSrc: "https://github.com/kalyan-maker/Firebase-react-app",
    description:
      "A Complete Quiz Application which user select the language and take test based on topic",
    stack: ["React.js", "Firebase"],
  },
  {
    label: "Chat App",
    imgSrc: "/static/images/chatapp.png",
    src: "https://mern-chatapp.netlify.app/",
    githubSrc: "https://github.com/kalyan-maker/mernchat",
    description:
      "A Complete Chat Application which user create a team and join team to chat with his teammates",
    stack: ["React.js", "expressjs", "Mongodb"],
  },
  {
    label: "Expensive App",
    imgSrc: "/static/images/expensive1.png",
    src: "https://expensive.herokuapp.com/",
    githubSrc: "https://github.com/kalyan-maker/expensive-tracker",
    description:
      "A Complete Expense Tracker Application which Track and Manage your expenses.",
    stack: ["React.js", "expressjs", "Mongodb"],
  },
];
